import type { ReactNode } from "react";

export const DEFAULT_CHART_HEIGHT = "300px";
export const DEFAULT_VERTICAL_CHART_HEIGHT = "450px";

// Compact variants (~half height) for embedding charts inside cards that
// supply their own frame and title, so the chart reads as inline evidence
// rather than a standalone figure.
export const COMPACT_CHART_HEIGHT = "150px";
export const COMPACT_VERTICAL_CHART_HEIGHT = "225px";

/**
 * Parses and validates JSON data from React children using a schema.
 * Handles the conversion from React children to JSON string to validated typed object.
 *
 * @param children - React children that should contain JSON string data
 * @param schema - Schema object with a parse method (e.g., Zod schema)
 * @returns Validated data matching the schema type
 * @throws {Error} If JSON parsing or schema validation fails
 */
export function parseJsonChildren<T>(
  children: ReactNode,
  schema: { parse: (data: unknown) => T },
): T {
  const jsonString =
    typeof children === "string" ? children : String(children ?? "");
  const parsedData = JSON.parse(jsonString);
  return schema.parse(parsedData);
}
